<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('phone')">
          <el-input
            v-model="queryForm.phone"
            size="small"
            :placeholder="$t('phone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('type')">
          <el-select
            v-model="queryForm.type"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('Bug Report')" value="1"></el-option>
            <el-option :label="$t('Feature Request')" value="2"></el-option>
            <el-option :label="$t('General Feedback')" value="3"></el-option>
            <el-option :label="$t('Complaint')" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('Pending')" value="0"></el-option>
            <el-option :label="$t('Under Review')" value="1"></el-option>
            <el-option :label="$t('Resolved')" value="2"></el-option>
            <el-option :label="$t('Rejected')" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>

        <el-table-column
          prop="customer"
          fixed="left"
          :label="$t('ID')"
          width="60"
        >
          <template slot-scope="scope">
            {{ scope.row.customerId }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerPhoneNo"
          :label="$t('phone')"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.customerPhoneNo }}
          </template>
        </el-table-column>

        <el-table-column prop="type" :label="$t('type')" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1" class="text-danger">{{
              $t("Bug Report")
            }}</span>
            <span v-if="scope.row.type == 2" class="text-warning">{{
              $t("Feature Request")
            }}</span>
            <span v-if="scope.row.type == 3" class="primary">{{
              $t("General Feedback")
            }}</span>
            <span v-if="scope.row.type == 4" class="text-danger">{{
              $t("Complaint")
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="title" :label="$t('title')" width="160">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          :label="$t('Description')"
          width="220"
        >
          <template slot-scope="scope">
            {{ scope.row.description }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("Pending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-warning">{{
              $t("Under Review")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-success">{{
              $t("Resolved")
            }}</span>
            <span v-if="scope.row.status == 3" class="text-danger">{{
              $t("Rejected")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="adminReply"
          :label="$t('adminReply')"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.adminReply }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.createTime).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          :label="$t('updateTime')"
          width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.updateTime).format("ymdhms") }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('extend')" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status != 2 && scope.row.status != 3"
              size="mini"
              type="primary"
              @click="openCheckApply(scope.row)"
            >
              {{ $t("check") }}
            </el-button>
            <el-tag v-else type="success" size="small">
              {{ $t("resolved") }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isCheckApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="checkForm" :rules="rules" ref="checkForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>
        <el-form-item :label="$t('customer')">
          <el-input
            size="medium"
            v-model="checkForm.customerId"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('phone')">
          <el-input
            size="medium"
            v-model="checkForm.customerPhoneNo"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('type')">
          <template>
            <span v-if="checkForm.type == 1">{{ $t("Bug Report") }}</span>
            <span v-if="checkForm.type == 2">{{ $t("Feature Request") }}</span>
            <span v-if="checkForm.type == 3">{{ $t("General Feedback") }}</span>
            <span v-if="checkForm.type == 4">{{ $t("Complaint") }}</span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('title')">
          <el-input size="medium" v-model="checkForm.title" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('Description')">
          <el-input
            type="textarea"
            size="medium"
            v-model="checkForm.description"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('creationTime')" prop="createTime">
          <el-input
            size="medium"
            v-model="checkForm.createTime"
            disabled
          ></el-input>
        </el-form-item>

        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="1" border>{{
            $t("Under Review")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="2" border>{{
            $t("Resolved")
          }}</el-radio>
          <el-radio v-model="checkForm.status" :label="3" border>{{
            $t("Rejected")
          }}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('adminReply')" prop="adminReply">
          <el-input
            type="textarea"
            size="medium"
            v-model="checkForm.adminReply"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import suggestions from "@/api/suggestions";

export default {
  name: "Suggestions",
  data() {
    return {
      isLoading: false,
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,

      queryForm: {},
      //是否显示审核申请弹框
      isCheckApply: false,
      //弹框标题
      applyTitle: "check",

      //申请表单
      applyForm: {},
      //审核表单
      checkForm: {},
      orgList: [],
    };
  },
  computed: {
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
  },
  methods: {
    getList() {
      let _this = this;
      _this.isLoading = true;
      suggestions.getList({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        },
      });
      _this.isLoading = false;
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    openCheckApply(row) {
      this.checkForm = {
        id: row.id,
        status: row.status,
        type: row.type,
        title: row.title,
        description: row.description,
        customerPhoneNo: row.customerPhoneNo,
        customerId: row.customerId,
        createTime: row.createTime,
      };

      this.isCheckApply = true;
    },

    /**提交充值申请 */
    onSubmitCheckResult(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        suggestions.checkApply({
          param: _this[refName],
          success: (res) => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isCheckApply = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          },
        });
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.recharge-apply {
  #org-info-from {
    .el-col-8 {
      margin-bottom: 31px;
    }
  }

  .testes {
    animation: identifier 300ms;
  }
  @keyframes identifier {
    0% {
      height: 0px;
    }
    100% {
      height: 100px;
    }
  }
}
</style>
